import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { FullDetailPage } from './pages/FullDetailPage';
import { WashWaxPage } from './pages/WashWaxPage';
import { BasicWashPage } from './pages/BasicWashPage';
import { AboutPage } from './pages/AboutPage';
import { SpecialsPage } from './pages/SpecialsPage';
import { GalleryPage } from './pages/GalleryPage';
import { ReviewsPage } from './pages/ReviewsPage';
import { ContactPage } from './pages/ContactPage';
import { InteriorDetailingPage } from './pages/InteriorDetailingPage';
import { ExteriorDetailingPage } from './pages/ExteriorDetailingPage';
import { HybridCeramicSprayPage } from './pages/HybridCeramicSprayPage';
import { HeadlightRestorationPage } from './pages/HeadlightRestorationPage';
import { MobileDetailingPage } from './pages/MobileDetailingPage';
import { EngineBayDetailingPage } from './pages/EngineBayDetailingPage';
import { CityPage } from './pages/CityPage';
import { CityAliasRedirect } from './pages/CityAliasRedirect';
import { NotFoundPage } from './pages/NotFoundPage';
import { ContentExportPage } from './pages/ContentExportPage';
import { FaqPage } from './pages/FaqPage';
export function App() {
  useEffect(() => {
    // Google Analytics (gtag.js)
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-BBSL5F5SDB';
    document.head.appendChild(script);
    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-BBSL5F5SDB');
      gtag('config', 'AW-349742034');
    `;
    document.head.appendChild(inlineScript);
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="35yomiyqxk0x">
      <Routes data-id="element-1" data-mp="35gnb7x88fm5">
        <Route element={<SiteLayout data-id="element-3" data-mp="34ndtz6vvc0b" />} data-id="element-2" data-mp="34x0pdwmt31s">
          {/* Primary pages */}
          <Route path="/" element={<HomePage data-id="element-5" data-mp="3uc9k7zkzlskv" />} data-id="element-4" data-mp="3udkr489qbgg7" />
          <Route path="/services" element={<ServicesPage data-id="element-7" data-mp="d57h17dyqql6" />} data-id="element-6" data-mp="3uf5ixq4nslad" />
          <Route path="/full-detail" element={<FullDetailPage data-id="element-9" data-mp="d2bibguajxvo" />} data-id="element-8" data-mp="d3cvprys4wgk" />
          <Route path="/wash-wax" element={<WashWaxPage data-id="element-11" data-mp="86w60tbxma1d" />} data-id="element-10" data-mp="851lhg4kojxt" />
          <Route path="/basic-wash" element={<BasicWashPage data-id="element-13" data-mp="3gkv0trn63pda" />} data-id="element-12" data-mp="83i0xdbvvmq8" />
          <Route path="/about" element={<AboutPage data-id="element-15" data-mp="3gja6o34rm8fy" />} data-id="element-14" data-mp="3gm647qcpav3v" />
          <Route path="/specials" element={<SpecialsPage data-id="element-17" data-mp="3bncnzq614q00" />} data-id="element-16" data-mp="3bmjqzgwvhev2" />
          <Route path="/gallery" element={<GalleryPage data-id="element-19" data-mp="3qb7jfebf98gs" />} data-id="element-18" data-mp="3bo4kd37garrc" />
          <Route path="/reviews" element={<ReviewsPage data-id="element-21" data-mp="3qcr2tdsdjzms" />} data-id="element-20" data-mp="3qbfur1rwc5pv" />
          <Route path="/contact" element={<ContactPage data-id="element-23" data-mp="3lk7mi92ayqea" />} data-id="element-22" data-mp="3qd0owqaatmn7" />
          <Route path="/faq" element={<FaqPage data-id="element-25" data-mp="3liehszb92g8x" />} data-id="element-24" data-mp="3liwjwcklfoor" />

          {/* Specialty service pages */}
          <Route path="/services/interior-detailing" element={<InteriorDetailingPage data-id="element-27" data-mp="2sw21dl7c6zdx" />} data-id="element-26" data-mp="2xtlnt8e6uigy" />
          <Route path="/services/exterior-detailing" element={<ExteriorDetailingPage data-id="element-29" data-mp="18dri7slud9c8" />} data-id="element-28" data-mp="2sv0pjeihy8v5" />
          <Route path="/services/hybrid-ceramic-spray" element={<HybridCeramicSprayPage data-id="element-31" data-mp="18by9m7ro4f1l" />} data-id="element-30" data-mp="18cq6dlx04itg" />
          <Route path="/services/headlight-restoration" element={<HeadlightRestorationPage data-id="element-33" data-mp="1d6awysw9maim" />} data-id="element-32" data-mp="1d4rd6sbehhc3" />
          <Route path="/services/mobile-detailing" element={<MobileDetailingPage data-id="element-35" data-mp="ydik298ahdu7" />} data-id="element-34" data-mp="ygd3pyjhaumk" />
          <Route path="/services/engine-bay-detailing" element={<EngineBayDetailingPage data-id="element-37" data-mp="13ey3jwutjcah" />} data-id="element-36" data-mp="13e54li23pr2w" />

          {/* Retired URLs, redirected so existing links and rankings carry over. */}
          <Route path="/services/full-car-detail" element={<Navigate to="/full-detail" replace data-id="element-39" data-mp="1w211amro7izo" />} data-id="element-38" data-mp="1w3c16bhzw6li" />
          <Route path="/services/ceramic-coating" element={<Navigate to="/services/hybrid-ceramic-spray" replace data-id="element-41" data-mp="1i2sy7isdzqq7" />} data-id="element-40" data-mp="1i3ktstlzhogh" />

          {/* City landing pages */}
          <Route path="/mobile-detailing-:slug" element={<CityPage data-id="element-43" data-mp="6onrwj4pb4rp" />} data-id="element-42" data-mp="1m3l8mfczw1o2" />
          <Route path="/ventura-county/:slug" element={<CityAliasRedirect data-id="element-45" data-mp="6qif643g38yy" />} data-id="element-44" data-mp="6o5uvka7smiq" />

          <Route path="*" element={<NotFoundPage data-id="element-47" data-mp="ar27mud2poer" />} data-id="element-46" data-mp="aqiqhfv8z41s" />
        </Route>
        {/* Documentation-only content export. Not linked in navigation, noindex. */}
        <Route path="/content-export" element={<ContentExportPage data-id="element-49" data-mp="m6p24c2xyyn2" />} data-id="element-48" data-mp="qygmu5zf2a5a" />
      </Routes>
    </BrowserRouter>;
}